module.exports = __webpack_public_path__ + "img/dragon.ab32af6f.svg";